module.exports = __webpack_public_path__ + "media/online-video-cutter_1.cbcb048f.mp4";